/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponsePlanItem } from './ResponsePlanItem';
import {
    ResponsePlanItemFromJSON,
    ResponsePlanItemFromJSONTyped,
    ResponsePlanItemToJSON,
    ResponsePlanItemToJSONTyped,
} from './ResponsePlanItem';

/**
 * 
 * @export
 * @interface ResponseGetReportPlansCsvListResponse
 */
export interface ResponseGetReportPlansCsvListResponse {
    /**
     * 
     * @type {Array<ResponsePlanItem>}
     * @memberof ResponseGetReportPlansCsvListResponse
     */
    items?: Array<ResponsePlanItem>;
}

/**
 * Check if a given object implements the ResponseGetReportPlansCsvListResponse interface.
 */
export function instanceOfResponseGetReportPlansCsvListResponse(value: object): value is ResponseGetReportPlansCsvListResponse {
    return true;
}

export function ResponseGetReportPlansCsvListResponseFromJSON(json: any): ResponseGetReportPlansCsvListResponse {
    return ResponseGetReportPlansCsvListResponseFromJSONTyped(json, false);
}

export function ResponseGetReportPlansCsvListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetReportPlansCsvListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ResponsePlanItemFromJSON)),
    };
}

export function ResponseGetReportPlansCsvListResponseToJSON(json: any): ResponseGetReportPlansCsvListResponse {
    return ResponseGetReportPlansCsvListResponseToJSONTyped(json, false);
}

export function ResponseGetReportPlansCsvListResponseToJSONTyped(value?: ResponseGetReportPlansCsvListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ResponsePlanItemToJSON)),
    };
}

